"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var image_1 = __importDefault(require("next/image"));
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var MethodImage = function (_a) {
    var images = _a.images, slug = _a.slug;
    var getPaymentImagePath = (0, react_1.useCallback)(function (methodSlug) { return "/img/payments/".concat(methodSlug, ".svg"); }, []);
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.imageContainer) }, (images === null || images === void 0 ? void 0 : images.logo) ? (react_1.default.createElement("img", { src: images.logo, width: 118, height: 32, className: styles_module_scss_1.default.image, alt: slug })) : (react_1.default.createElement(image_1.default, { src: getPaymentImagePath(slug), width: 118, height: 32, alt: slug, className: styles_module_scss_1.default.image }))));
};
exports.default = MethodImage;
